import { Component, OnInit, ViewChild } from '@angular/core';
import { ClienteService } from '../../../services/cliente/cliente.service';
import { HttpErrorResponse } from '@angular/common/http';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { LocalizacionService } from '../../../services/localizacion/localizacion.service';
import { ConfigService } from '../../../services/config/config.service';
import { MenuItem, MessageService } from 'primeng/api';
import { supplierIntegrationService } from '../../../services/supplierIntegration/supplier-integration.service';
import { timeout } from 'rxjs';
import { CotizacionService } from '../../../services/cotizacion/cotizacion.service';
import { VentaService } from '../../../services/venta/venta.service';
import { CatalogoService } from '../../../services/catalogo/catalogo.service';
import { ProductoService } from '../../../services/producto/producto.service';
import { Router } from '@angular/router';
import { ProveedorService } from '../../../services/proveedor/proveedor.service';
import { AutoComplete } from 'primeng/autocomplete';


@Component({
  selector: 'app-cotizacion',
  templateUrl: './cotizacion.component.html',
  styleUrls: ['./cotizacion.component.scss'],
  standalone: false,
  providers: [MessageService]
})
export class CotizacionComponent implements OnInit {
  loadMenu: boolean = true;
  load: boolean = false;
  resultsLsClients: Array<any> = [];
  @ViewChild('autocomplete') autocomplete: AutoComplete | undefined;
  fieldSearch: string = "";
  token: any = {};
  infoUser: any = {};
  empresa: any = {};
  infoParametrizacion: any = {};
  selectedClient: any = {};
  digito: number | undefined;

  // customer information
  divInfoClient: boolean = false;
  listDptos: Array<any> = [];
  listCities: Array<any> = [];
  listCitiesShipping: Array<any> = [];
  listIdentificationType: Array<any> = [];
  citySelected: any = {};
  editFormClient: boolean = false;
  messageClient: string = "";
  formClient = new FormGroup({
    tipo: new FormControl({ idTipoIdentificacion: 0 }, Validators.required),
    identificacion: new FormControl(null, [Validators.required, Validators.pattern(/^(0|[1-9][0-9]*)$/)]),
    razonSocial: new FormControl('', Validators.required),
    nombres: new FormControl('', [Validators.required, Validators.maxLength(200)]),
    direccion: new FormControl(''),
    departamento: new FormControl(null),
    ciudad: new FormControl(null),
    correo: new FormControl('', [Validators.email, Validators.required]),
    telefono: new FormControl('', [Validators.pattern(/^(0|[1-9][0-9]*)$/)])
  });

  listCanalIngreso: Array<any> = [];
  selectedChannelIngreso: any = {};
  infoTercero: any = {};
  displayInfoTercero: boolean = false;
  //array for price list
  divInfoListPrices: boolean = true;
  listOfPrice: Array<any> = [];
  selectedListOfPrice: any = {};
  lsChannelSales: Array<any> = [];
  selectedChannel: any = {};
  chkSameAddress: boolean = false;
  chkPickUpOnSite: boolean = false; // variable pare fecinir la recogida local
  contactShipping: string = "";
  addressShipping: string = "";
  stateShipping: any = {};
  cityShipping: any = {};
  // searach of SKU
  wordSearch: String = "";
  timerSearch: any;
  listProducts: Array<any> = [];
  listCategorization: Array<any> = []; //info by refecnce
  listCategorizationFilter: Array<any> = [];
  listProductsFilter: Array<any> = [];
  listProductsFilterCategory: Array<any> = [];
  idSelectedCategory: number | undefined;
  categoriaSelected: Array<any> | undefined;
  listPolitica: Array<any> = [];
  selectedPolitica: any = {};
  // quotation
  cotizacionCurrent: any = {};
  dataShippingTemp: Array<any> = [];
  varsCurrentQuotation: any = []; // tipoIndetificacion/nit/idListaPrecios/canal
  activeIndex: number = 0;
  urlImages: string = "";



  public constructor(private client: ClienteService,
    private localizacion: LocalizacionService,
    private config: ConfigService,
    private message: MessageService,
    private supplierIntegration: supplierIntegrationService,
    private cotizacion: CotizacionService,
    private venta: VentaService,
    private catalogo: CatalogoService,
    private producto: ProductoService,
    private router: Router,
    private proveedor: ProveedorService
  ) { }

  ngOnInit(): void {
    this.token = JSON.parse(localStorage.getItem('token') ?? "".toString());
    this.infoUser = JSON.parse(localStorage.getItem('infoUser') ?? "[]");
    this.empresa = JSON.parse(localStorage.getItem('empresa') ?? "[]");
    this.infoParametrizacion = JSON.parse(localStorage.getItem('parametros') ?? "");
    this.urlImages = this.config.urlIMG;

    // get information of dptos
    this.listDptos = JSON.parse(localStorage.getItem('listDptos') ?? "[]");


    // get identification types
    this.client.getTypeIndetification(this.token.token).subscribe({
      next: (response) => { this.listIdentificationType = response as Array<any>; },
      error: (error: HttpErrorResponse) => { this.config.handleError(error); }
    });

    // get possible client entry channel
    this.client.getPossibleEntryChannel(this.token.token).subscribe({
      next: (response) => {
        this.listCanalIngreso = response as Array<any>;
        // get commercial policies
        this.venta.getCommercialPolicy(this.token.token).subscribe({
          next: (response1: any) => {
            this.listPolitica = response1 as Array<any>;
            if (this.listPolitica.length == 1)
              this.selectedPolitica = this.listPolitica[0];
          },
          error: (error: HttpErrorResponse) => { this.config.handleError(error); }
        })
      },
      error: (error: HttpErrorResponse) => { this.config.handleError(error); }
    })



    // There is a quotation in progress
    this.varsCurrentQuotation = (window.location.hash.substring(1, window.location.hash.length).replace(/%20/g, ' ').trim().split('/'));
    if (this.varsCurrentQuotation.length > 0) {
      if (this.varsCurrentQuotation[0] != '') {
        this.activeIndex = 1;
        let row: any = { value: { tipoIdentificacion: this.varsCurrentQuotation[0], identificacion: this.varsCurrentQuotation[1] } }
        this.searchItemView(row);
        // load shipping address
        this.dataShippingTemp = (localStorage.getItem('dataShipping') ?? "").split('||');
        if (this.dataShippingTemp[1] != '') {
          this.contactShipping = this.dataShippingTemp[0];
          this.addressShipping = this.dataShippingTemp[1];
          this.stateShipping = this.listDptos.filter(row => row.idDepartamento == this.dataShippingTemp[2])[0];
          this.loadCitiesShipping();
        }

        this.divInfoListPrices = false;

      }
      else {
        this.varsCurrentQuotation = [];
        this.newQuotation();
      }
    }

    // get list of prices current
    this.cotizacion.getListOfPrice(this.token.token).subscribe({
      next: (response) => {
        this.listOfPrice = response as Array<any>;
        // there is a quotation in progress
        if (this.varsCurrentQuotation.length > 0) {
          this.selectedListOfPrice = this.listOfPrice.filter(row => row.idListaPrecios == this.varsCurrentQuotation[2])[0];
        }
        // get categorizacion de producto
        if (!localStorage.getItem("categorizationList"))
          this.producto.getCategorizacion(this.token.token).subscribe((response) => {
            this.listCategorization = response as Array<any>;
            localStorage.setItem("categorizationList", JSON.stringify(this.listCategorization))

            // get products in general
            if (!localStorage.getItem("listProducts"))
              this.catalogo.getProductosProveedor(this.token.token).subscribe((response) => {
                this.listProducts = response as Array<any>;
                localStorage.setItem("listProducts", JSON.stringify(this.listProducts))

              });
          });
        else {
          this.listCategorization = JSON.parse(localStorage.getItem("categorizationList") ?? "[]");
          this.listProducts = JSON.parse(localStorage.getItem("listProducts") ?? "[]");
        }
      },
      error: (error: HttpErrorResponse) => { this.config.handleError(error); }
    });


    // get channel of sales
    this.venta.getChannelSales(this.token.token).subscribe({
      next: (response) => {
        this.lsChannelSales = response as Array<any>;
        // there is a quotation in progress
        if (this.varsCurrentQuotation.length > 0) {
          this.selectedChannel = this.lsChannelSales.filter(row => row.idCanalVenta == this.varsCurrentQuotation[3])[0];
          setTimeout(() => {
            this.getCotizacion();
          }, 3000);

        }
      },
      error: (error: HttpErrorResponse) => { this.config.handleError(error); }
    })



  }

  loadCitiesShipping = () => {
    this.localizacion.getCities(this.token.token, this.stateShipping.idDepartamento).subscribe({
      next: (response) => {
        this.listCitiesShipping = response as Array<any>;
        // there is a quotation in progress
        if (this.varsCurrentQuotation.length > 0) {
          this.cityShipping = this.listCitiesShipping.filter(row => row.idCiudad == parseInt(this.dataShippingTemp[3]))[0];
        }
      },
      error: (error: HttpErrorResponse) => { this.config.handleError(error); }
    })
  }

  loadCities = () => {
    this.localizacion.getCities(this.token.token, (this.formClient.controls.departamento.value as any).idDepartamento).subscribe({
      next: (response) => {
        this.listCities = response as Array<any>;
        // there is a selected city
        if (this.citySelected?.idCiudad > 0)
          this.formClient.controls.ciudad.setValue(this.listCities.filter(row => row.idCiudad == this.citySelected?.idCiudad)[0]);
      },
      error: (error: HttpErrorResponse) => { this.config.handleError(error); }
    })
  }

  /* loadCitiesBlank = () => {
    this.localizacion.getCities(this.token.token, (this.stateShipping as any).idDepartamento).subscribe({
      next: (response) => {
        this.listCities = response as Array<any>;
      },
      error: (error: HttpErrorResponse) => { this.config.handleError(error); }
    })
  } */

  searchItem = (string: any) => {
    this.client.getProspectiveClients(this.token.token, string.query).subscribe({
      next: (response) => {
        this.resultsLsClients = response as Array<any>;
        if (this.resultsLsClients.length == 0) {
          //this.autocomplete?.hide();
          // asignación de valores si no existe
          if (isNaN(parseInt(string.query))) {
            this.formClient.controls.nombres.setValue(string.query);
            this.formClient.controls.identificacion.reset()
          }
          else {
            this.formClient.controls.identificacion.setValue(string.query);
            this.formClient.controls.nombres.reset();
          }
        }
      },
      error: (error: HttpErrorResponse) => { this.config.handleError(error); }
    })

  }

  // una vez seleccionado s eimporta la información
  searchItemView = (row: any) => {
    this.resultsLsClients = [];
    this.load = true;

    this.client.getClients(this.token.token, (row.value?.tipoIdentificacion ?? 1), row.value.identificacion).subscribe({
      next: (response) => {
        this.selectedClient = response as any;
        this.load = false;
        // fill form
        let typeIndetification: any = this.listIdentificationType.filter(row => row?.idTipoIdentificacion == this.selectedClient[0].idTipoIdentificacion)[0];
        this.formClient.controls.tipo.setValue(typeIndetification);
        this.formClient.controls.identificacion.setValue(this.selectedClient[0].identificacion);
        // verification digit calculation
        this.digito = this.config.getDigitVerification(this.selectedClient[0].identificacion.toString());

        this.formClient.controls.razonSocial.setValue(this.selectedClient[0].razonSocial);
        this.formClient.controls.nombres.setValue(this.selectedClient[0].nombres);
        this.formClient.controls.correo.setValue(this.selectedClient[0].email);
        this.formClient.controls.direccion.setValue(this.selectedClient[0].direccion);
        this.formClient.controls.telefono.setValue(this.selectedClient[0].telefono);

        // si no tiene lista de precios asignada, se toma la que este por defecto
        if (!this.selectedClient[0]?.clienteProcedencia[0]?.idListaPrecios)
          this.selectedListOfPrice = this.listOfPrice.filter((row: any) => { return row.default == true })[0];
        else
          this.selectedListOfPrice = this.listOfPrice.filter((row: any) => { return row.idListaPrecios == this.selectedClient[0]?.clienteProcedencia[0]?.idListaPrecios })[0];

        // campos de complemento para estadisticas
        this.selectedChannelIngreso = this.listCanalIngreso.filter((row: any) => { return row.idProcedencia == this.selectedClient[0]?.clienteProcedencia[0]?.idProcedencia })[0];

        /* if (this.selectedListOfPrice?.idListaPrecios > 0)
          this.getCotizacion() */

        // get city and depto
        if (!!this.selectedClient[0].idCiudad)
          this.localizacion.getCitiesId(this.token.token, this.selectedClient[0].idCiudad).subscribe({
            next: (response1) => {
              this.citySelected = response1;
              this.formClient.controls.departamento.setValue((response1 as any).idDepartamentoNavigation);
              this.loadCities();
            },
            error: (error: HttpErrorResponse) => { this.config.handleError(error); }
          });
        //get entry channel
        if (this.selectedClient[0]?.clienteProcedencia.length > 0)
          this.selectedChannelIngreso = this.listCanalIngreso.filter(row => row.idProcedencia == this.selectedClient[0]?.clienteProcedencia[0]?.idProcedencia)[0];
      },
      error: (error: HttpErrorResponse) => { this.config.handleError(error); }
    })
  }

  searchClient() {
    if (((this.formClient.controls.identificacion.value ?? "") != '') && ((this.formClient.controls.tipo.value?.idTipoIdentificacion ?? 0) > 0)) {
      // verification digit calculation
      this.digito = this.config.getDigitVerification(this.formClient.controls.identificacion.value ?? "");

      this.client.getClients(this.token.token, this.formClient.controls.tipo.value?.idTipoIdentificacion ?? 1,
        this.formClient.controls.identificacion.value ?? "").subscribe((response) => {
          this.selectedClient = response as Array<any>;
          if (this.selectedClient.length > 0) {
            this.formClient.controls.nombres.setValue(this.selectedClient[0].nombres);
            this.formClient.controls.telefono.setValue(this.selectedClient[0].telefono);
            this.formClient.controls.correo.setValue(this.selectedClient[0].email);
            this.formClient.controls.direccion.setValue(this.selectedClient[0].direccion);
            this.formClient.controls.razonSocial.setValue(this.selectedClient[0].razonSocial ?? 'N/A');

            // get city and depto
            if (!!this.selectedClient[0].idCiudad)
              this.localizacion.getCitiesId(this.token.token, this.selectedClient[0].idCiudad).subscribe({
                next: (response1) => {
                  this.citySelected = response1;
                  this.formClient.controls.departamento.setValue((response1 as any).idDepartamentoNavigation);
                  this.loadCities();
                },
                error: (error: HttpErrorResponse) => { this.config.handleError(error); }
              })
          } else
            this.searchClientExternSystem();
        });
    }
  }

  /**
   * Buscar información de un sistema externo integrado
   */
  searchClientExternSystem = () => {
    /*Import Clients of SIIGO*/
    if (!!localStorage.getItem('tokenSIIGO')) {
      let tokenSIIGO = JSON.parse(localStorage.getItem('tokenSIIGO') ?? "");
      this.supplierIntegration.getClientSiigo(this.token.token, tokenSIIGO, this.formClient.controls.identificacion.value ?? "")
        .subscribe({
          next: (response) => {
            this.infoTercero = response as Array<any>;
            if (this.infoTercero.results.length > 0) {
              // filtrar la información del tercero que este activa en el campo sucursal
              this.infoTercero.results.filter((row: any) => { return row.active ?? false });
              this.displayInfoTercero = true;
            }
          },
          error: (error: HttpErrorResponse) => { this.config.handleError(error); }
        });
    }
  }

  /**
   * LLenar el formulario con información de SIIGO
   */
  fillFormClientExternSystem = () => {
    if (!!localStorage.getItem('tokenSIIGO')) {
      if (this.infoTercero.results.length > 0) {
        this.formClient.controls.tipo.setValue(this.listIdentificationType.filter(row => { return row.codProveedorDian1 == this.infoTercero.results[0].id_type.code.toString() })[0]);
        this.formClient.controls.nombres.setValue(this.infoTercero.results[0].contacts[0].first_name + " " + this.infoTercero.results[0].contacts[0].last_name);
        this.formClient.controls.telefono.setValue(this.infoTercero.results[0].phones[0].phone);
        this.formClient.controls.correo.patchValue(this.infoTercero.results[0].contacts[0].email);
        this.formClient.controls.direccion.setValue(this.infoTercero.results[0].address.address);
        this.formClient.controls.razonSocial.setValue(this.infoTercero.results[0].name.join(' '));

        //show dpto
        this.formClient.controls.departamento.setValue(this.listDptos.filter(row => row.codDepartamento == this.infoTercero.results[0].address.city.state_code)[0]);
        // load cities and selected
        this.localizacion.getCities(this.token.token, (this.formClient.controls.departamento.value as any).idDepartamento).subscribe({
          next: (response) => {
            this.listCities = response as Array<any>;
            // there is a selected city
            this.formClient.controls.ciudad.setValue(this.listCities.filter(row => row.codCiudad == this.infoTercero.results[0].address.city.city_code)[0]);
            this.displayInfoTercero = false;
          },
          error: (error: HttpErrorResponse) => {
            this.displayInfoTercero = false;
            this.config.handleError(error);
          }
        })
      }
    }
  }

  clearFormClient = () => {
    this.editFormClient = false;
    this.divInfoClient = false;
    this.formClient.reset();
    //this.divInfoListPrices = false;
  }

  saveInfoClient = () => {
    // si se edita la información es necesario guardar y validar la información del cliente relacionada
    if (this.editFormClient) {
      // according to the type of identification fields are filled in
      const tipoIndetificacion: any = this.formClient.controls.tipo.value;
      if (tipoIndetificacion.idTipoIdentificacion !== 3)
        this.formClient.controls.razonSocial.setValue('NA')
     /*  else
        this.formClient.controls.razonSocial.setValue('')
 */
      if (this.formClient.valid) {
        //validar el canal de ingreso diligenciado
        if (this.selectedChannelIngreso?.idProcedencia == 0) {
          this.message.add({ severity: 'warn', summary: 'Favor seleccione la forma de ingreso' });
          return;
        }
        this.load = true;
        this.citySelected = this.formClient.controls.ciudad.value;
        const data = {
          "idCliente": this.selectedClient[0]?.idCliente ?? 0,
          "idTipoIdentificacion": this.formClient.controls.tipo.value?.idTipoIdentificacion ?? 1,
          "digito": this.digito,
          "identificacion": this.formClient.controls.identificacion.value,
          "razonSocial": this.formClient.controls.razonSocial.value?.replace('No aplica', '') ?? '',
          "nombres": this.formClient.controls.nombres.value,
          "direccion": this.formClient.controls.direccion.value ?? '',
          "telefono": this.formClient.controls.telefono.value ?? '',
          "email": this.formClient.controls.correo.value,
          "idCiudad": !this.citySelected.idCiudad ? null : this.citySelected.idCiudad,
          "clienteProcedencia": this.selectedChannelIngreso?.idProcedencia > 0 ? [{
            idCliente: this.selectedClient[0]?.idCliente ?? 0,
            idProcedencia: this.selectedChannelIngreso.idProcedencia,
            fecha: new Date()
          }] : null
        }
        // SEND TO CREATE CLIENT
        this.client.setClient(this.token.token, data).subscribe({
          next: (response) => {
            this.load = false;
            this.message.add({ severity: 'success', summary: 'Actualización realizada, ya puede proceder con la cotización' });
            setTimeout(() => { this.formClient.reset(); this.clearFormClient(); }, 3000)
          },
          error: (error: HttpErrorResponse) => {
            this.load = false;
            this.message.add({ severity: 'danger', summary: 'Se ha presentado un error, favor validar la información' });
            this.config.handleError(error);
          }
        })

      } else
        this.message.add({ severity: 'warn', summary: 'Favor ingrese la información requerida' })
    } else {
      //validar el canal de ingreso diligenciado
      if (this.selectedChannelIngreso?.idProcedencia > 0) {
        // create object
        const data = {
          idCliente: this.selectedClient[0]?.idCliente,
          idProcedencia: this.selectedChannelIngreso.idProcedencia,
          fecha: new Date()
        }
        this.load = true;
        this.client.setChannelEntryClient(this.token.token, data).subscribe({
          next: (response) => { this.message.add({ severity: 'success', summary: 'Actualización realizada' }); this.load = false; },
          error: (error: HttpErrorResponse) => {
            this.load = false;
            this.config.handleError(error);
            this.message.add({ severity: 'danger', summary: 'Se ha presentado un error, favor validar la información' })
          }
        })
      } else
        this.message.add({ severity: 'warn', summary: 'Favor seleccione la forma de ingreso' })
    }

  }

  eventChannel = () => {
    if (!this.selectedChannel.hasShippingAddress) {
      this.chkPickUpOnSite = true;
      this.setPickupOnSite()
    }
  }

  setShippingAddress = () => {
    if (this.chkSameAddress) {
      this.contactShipping = this.formClient.controls.nombres.value?.toUpperCase() ?? "";
      this.addressShipping = this.formClient.controls.direccion.value?.toUpperCase() ?? "";
      this.stateShipping = this.formClient.controls.departamento.value;
      this.cityShipping = this.formClient.controls.ciudad.value;
      this.loadCitiesShipping()

      // en caso de dar clic en la misma dirección de facturación y es elegido canal presencial, se cambia el canal de venta
      if (!this.selectedChannel.hasShippingAddress) {
        this.selectedChannel = {};
      }
      this.chkPickUpOnSite = false;
    } else {
      this.addressShipping = "";
      this.stateShipping = undefined
      this.cityShipping = undefined
      this.contactShipping = "";
      this.chkPickUpOnSite = true;
    }
    // en caso de provenir de una cotización existente
    if (this.varsCurrentQuotation.length > 0) {
      this.setShipping();
    }
  }

  setPickupOnSite = () => {
    if (this.chkPickUpOnSite) {
      this.addressShipping = "";
      this.stateShipping = undefined
      this.cityShipping = undefined
      this.contactShipping = "";
      this.chkSameAddress = false;

    } else {
      this.contactShipping = this.formClient.controls.nombres.value?.toUpperCase() ?? "";
      this.addressShipping = this.formClient.controls.direccion.value?.toUpperCase() ?? "";
      this.stateShipping = this.formClient.controls.departamento.value;
      this.cityShipping = this.formClient.controls.ciudad.value;
      this.chkSameAddress = true;
    }
    // en caso de provenir de una cotización existente
    if (this.varsCurrentQuotation.length > 0) {
      this.setShipping();
    }
  }

  searchItemsAuto = () => {
    clearTimeout(this.timerSearch);
    this.timerSearch = setTimeout(() => {
      this.searchItems();
      clearTimeout(this.timerSearch);
    }, 1000);

  }

  searchItems = () => {
    this.listCategorizationFilter = [{
      id: 0,
      label: 'VER TODOS',
      items: [],
      command: () => { this.filterSearchItems(0, 1); }
    }];
    // validaciones
    if (this.selectedListOfPrice?.idListaPrecios > 0) {
      if (this.selectedChannel?.idCanalVenta > 0) {
        if (this.chkPickUpOnSite || (this.cityShipping?.idCiudad > 0 || !this.selectedChannel.hasShippingAddress)) {
          if (this.wordSearch != "" && this.wordSearch.length > 1) {
            // obtener lista original
            this.listProducts = JSON.parse(localStorage.getItem("listProducts") ?? "[]");
            // proceder con la busqueda de productos
            this.divInfoListPrices = false;
            this.divInfoClient = false;
            this.activeIndex = 1;
            this.listProductsFilter = this.listProducts.filter((row: any) =>
              row.detalleListaPrecios.findIndex((item: any) => item.idListaPrecios == this.selectedListOfPrice?.idListaPrecios) > -1
              && (row.descripcionCorta.toLowerCase().includes(this.wordSearch.toLowerCase()) || row.descripcionLarga.toLowerCase().includes(this.wordSearch.toLowerCase())
                || row.codBarras.toLowerCase().includes(this.wordSearch.toLowerCase()) || row.marca.toLowerCase().includes(this.wordSearch.toLowerCase()))
            )

            /// iniciar el filtro de categorización y lista de precios a mostrar
            this.listProductsFilter.map((row: any) => {
              // eliminación de items de lista de precios no equivalentes al filtro
              row.detalleListaPrecios = row.detalleListaPrecios.filter((item: any) => {
                return item.idListaPrecios == this.selectedListOfPrice?.idListaPrecios
              })

              // revisión de la categorización
              row.categorizacion = row.categorizacionProducto?.isStrcategorizacionProveedor.split('|')
                .filter((element: any) => { return element != "" }).map((element: any) => {
                  //get category
                  let category: any = this.listCategorization.filter(item2 => { return item2.idCategorizacionProveedor == element });
                  if (category.length > 0) {
                    return {
                      id: element,
                      nameCategory: category[0]?.descripcion,
                      position: category[0]?.posicion
                    }
                  }
                  else
                    return;
                });

              // asignación al menu de las categorias de 6 niveles máximo
              // posiiones del array
              let listTempCategory: Array<number> = [];

              row.categorizacion.map((element: any) => {
                switch (element.position) {
                  case 1:
                    if (this.listCategorizationFilter.findIndex((line: any) => { return line.id == element.id }) == -1) {
                      this.listCategorizationFilter.push({
                        id: element.id,
                        label: element.nameCategory,
                        items: [],
                        command: () => {
                          this.filterSearchItems(element.id, element.position, row.categorizacion);
                        }
                      });
                      listTempCategory.push(this.listCategorizationFilter.length - 1);
                    } else
                      listTempCategory.push(this.listCategorizationFilter.findIndex((line: any) => { return line.id == element.id }));
                    break;
                  case 2:
                    if (this.listCategorizationFilter[listTempCategory[0]]?.items.findIndex((line: any) => line.id == element.id) == -1) {
                      this.listCategorizationFilter[listTempCategory[0]].items.push({
                        id: element.id,
                        label: element.nameCategory,
                        items: [],
                        command: () => { this.filterSearchItems(element.id, element.position, row.categorizacion); }
                      });
                      listTempCategory.push(this.listCategorizationFilter[listTempCategory[0]].items.length - 1);
                    }
                    else
                      listTempCategory.push(this.listCategorizationFilter[listTempCategory[0]]?.items.findIndex((line: any) => line.id == element.id));
                    break;
                  case 3:

                    if (this.listCategorizationFilter[listTempCategory[0]]?.items[listTempCategory[1]]?.items.findIndex((line: any) => line.id == element.id) == -1) {

                      this.listCategorizationFilter[listTempCategory[0]].items[listTempCategory[1]].items.push({
                        id: element.id,
                        label: element.nameCategory,
                        items: [],
                        command: () => { this.filterSearchItems(element.id, element.position, row.categorizacion); }
                      });
                      listTempCategory.push(this.listCategorizationFilter[listTempCategory[0]].items[listTempCategory[1]].items.length - 1);
                    }
                    else
                      listTempCategory.push(this.listCategorizationFilter[listTempCategory[0]]?.items[listTempCategory[1]]?.items.findIndex((line: any) => line.id == element.id))
                    break;
                  case 4:
                    if (this.listCategorizationFilter[listTempCategory[0]]?.items[listTempCategory[1]]?.items[listTempCategory[2]]?.items
                      .findIndex((line: any) => line.id == element.id) == -1) {
                      this.listCategorizationFilter[listTempCategory[0]].items[listTempCategory[1]].items[listTempCategory[2]].items.push({
                        id: element.id,
                        label: element.nameCategory,
                        items: [],
                        command: () => { this.filterSearchItems(element.id, element.position, row.categorizacion); }
                      });
                      listTempCategory.push(this.listCategorizationFilter[listTempCategory[0]].items[listTempCategory[1]].items[listTempCategory[2]].items.length - 1);
                    }
                    else
                      listTempCategory.push(this.listCategorizationFilter[listTempCategory[0]]?.items[listTempCategory[1]]?.items[listTempCategory[2]]?.items
                        .findIndex((line: any) => line.id == element.id));
                    break;
                  case 5:
                    if (this.listCategorizationFilter[listTempCategory[0]]?.items[listTempCategory[1]]?.items[listTempCategory[2]]?.items[listTempCategory[3]].items
                      .findIndex((line: any) => line.id == element.id) == -1) {
                      this.listCategorizationFilter[listTempCategory[0]].items[listTempCategory[1]].items[listTempCategory[2]].items[listTempCategory[3]].items.push({
                        id: element.id,
                        label: element.nameCategory,
                        items: [],
                        command: () => { this.filterSearchItems(element.id, element.position, row.categorizacion); }
                      });
                      listTempCategory.push(this.listCategorizationFilter[listTempCategory[0]].items[listTempCategory[1]].items[listTempCategory[2]].items[listTempCategory[3]].items.length - 1);
                    }
                    else
                      listTempCategory.push(this.listCategorizationFilter[listTempCategory[0]]?.items[listTempCategory[1]]?.items[listTempCategory[2]]?.items[listTempCategory[3]].items
                        .findIndex((line: any) => line.id == element.id));
                    break;
                  case 6:
                    if (this.listCategorizationFilter[listTempCategory[0]]?.items[listTempCategory[1]]?.items[listTempCategory[2]]?.items[listTempCategory[3]]?.items[listTempCategory[4]].items
                      .findIndex((line: any) => line.id == element.id) == -1) {
                      this.listCategorizationFilter[listTempCategory[0]].items[listTempCategory[1]].items[listTempCategory[2]].items[listTempCategory[3]].items[listTempCategory[4]].items.push({
                        id: element.id,
                        label: element.nameCategory,
                        items: [],
                        command: () => { this.filterSearchItems(element.id, element.position, row.categorizacion); }
                      });
                      listTempCategory.push(this.listCategorizationFilter[listTempCategory[0]].items[listTempCategory[1]].items[listTempCategory[2]].items[listTempCategory[3]].items[listTempCategory[4]].items.length - 1);
                    }
                    else
                      listTempCategory.push(this.listCategorizationFilter[listTempCategory[0]]?.items[listTempCategory[1]]?.items[listTempCategory[2]]?.items[listTempCategory[3]]?.items[listTempCategory[4]].items
                        .findIndex((line: any) => line.id == element.id))
                    break;
                }
              })
            });
            this.listProductsFilterCategory = this.listProductsFilter
          }
          else
            this.message.add({ severity: 'warn', summary: 'Favor ingrese palabras claves de busqueda' })
        }
        else
          this.message.add({ severity: 'warn', summary: 'Favor ingrese la información de despacho' })
      } else
        this.message.add({ severity: 'warn', summary: 'Favor seleccione el canal de venta' })
    } else
      this.message.add({ severity: 'warn', summary: 'Favor seleccione la lista de precios' })

  }


  filterSearchItems = (id: number, position: number, categoria?: any) => {

    if (id == 0)
      this.listProductsFilterCategory = this.listProductsFilter;
    else {
      this.categoriaSelected = categoria.slice(0, position);
      this.listProductsFilterCategory = this.listProductsFilter.filter(row => {
        return JSON.stringify(row.categorizacion.slice(0, position)) == JSON.stringify(categoria.slice(0, position))
      });
      // informative to css category
      this.idSelectedCategory = id;
    }

  }


  getCotizacion = () => {
    this.cotizacion.getCotizacion(this.token.token, this.selectedClient[0]?.idCliente, this.selectedListOfPrice.idListaPrecios)
      .subscribe({
        next: (response) => {
          this.cotizacionCurrent = response as any;
          // custom
          this.chkPickUpOnSite = this.cotizacionCurrent?.exemptShippingValue ?? false;
        },
        error: (error: HttpErrorResponse) => { this.config.handleError(error); }
      })
  }

  // add products
  setCotizacion = (row: any) => {
    row.loading = true;
    const data = {
      idCotizacion: this.cotizacionCurrent?.idCotizacion ?? 0,
      idCliente: this.selectedClient[0]?.idCliente,
      idListaPrecios: this.selectedListOfPrice.idListaPrecios,
      idCanalVenta: this.selectedChannel.idCanalVenta,
      idPoliticaComercial: this.selectedPolitica.idPoliticaComercial ?? null,
      estado: 1,
      dataShipping: this.contactShipping + '||' + this.addressShipping + '||' + (this.stateShipping?.idDepartamento ?? "") + '||' + (this.cityShipping?.idCiudad ?? ""),
      exemptShippingValue: this.chkPickUpOnSite ?? false,
      detalleCotizacionInicials: [{
        idCotizacion: this.cotizacionCurrent?.idCotizacion ?? 0,
        idProducto: row.idProducto,
        cantidad: 1,
        //precio: Number(((((row.detalleListaPrecios[0].precioPromocion < row.detalleListaPrecios[0].precio ? row.detalleListaPrecios[0].precioPromocion : row.detalleListaPrecios[0].precio)) / (((row.impuesto) / 100) + 1)) * 1/*cantidad*/).toFixed(2)),
        subtotal: Number(((((row.detalleListaPrecios[0].precioPromocion < row.detalleListaPrecios[0].precio ? row.detalleListaPrecios[0].precioPromocion : row.detalleListaPrecios[0].precio)) / (((row.impuesto) / 100) + 1)) * 1/*cantidad*/).toFixed(2)),
        impuesto: Number((((row.detalleListaPrecios[0].precioPromocion < row.detalleListaPrecios[0].precio ? row.detalleListaPrecios[0].precioPromocion : row.detalleListaPrecios[0].precio) * 1/*cantidad*/)).toFixed(2)) -
          //subtotal
          Number(((((row.detalleListaPrecios[0].precioPromocion < row.detalleListaPrecios[0].precio ? row.detalleListaPrecios[0].precioPromocion : row.detalleListaPrecios[0].precio)) / (((row.impuesto) / 100) + 1)) * 1/*cantidad*/).toFixed(2))
      }]

    }
    console.log(data);
    this.cotizacion.setCotizacion(this.token.token, data).subscribe({
      next: (response) => {
        row.loading = false;
        row.message = '<div class="p-message p-message-success p-3">Se ha incluido el producto en la cotización nro. ' + response + '</div>'
        this.getCotizacion();
      },
      error: (error: HttpErrorResponse) => { this.config.handleError(error); row.loading = false; }
    })
  }

  setShipping = () => {
    const data = {
      idCotizacion: this.cotizacionCurrent?.idCotizacion ?? 0,
      dataShipping: this.contactShipping + '||' + this.addressShipping + '||' + (this.stateShipping?.idDepartamento ?? "") + '||' + (this.cityShipping?.idCiudad ?? ""),
      exemptShippingValue: this.chkPickUpOnSite ?? false
    }
    this.load = true;
    this.cotizacion.setCotizacionShipping(this.token.token, data).subscribe({
      next: (response) => {
        this.load = false;
      },
      error: (error: HttpErrorResponse) => { this.config.handleError(error); this.load = false; }
    })
  }

  newQuotation = () => {
    this.dataShippingTemp = [];
    localStorage.removeItem('dataShipping');
    this.selectedClient = [];
    this.formClient.reset();
    this.router.navigate(['cotizacion/crear_cotizacion']);
    this.divInfoListPrices = true;
    this.selectedListOfPrice = {};
    this.selectedChannel = {};
    this.cotizacionCurrent = {};
    this.activeIndex = 0;
  }

  toSeeDetail = () => {
    //DetalleCotizacion
    this.router.navigate(['cotizacion/detalle_cotizacion', this.cotizacionCurrent.idCotizacion]);
  }

}
